module.exports = __webpack_public_path__ + "static/media/brios-cereales-b.43e9a6d9.webp";